// Highlights an element when a URL query param matches its data-highlight value.
//
// Usage:
//   <div data-highlight="my-section">...</div>
//
// Navigating to ?highlight=my-section will scroll to the element and blink it.
//
// Trigger via button:
//   <button data-action="highlight:trigger" data-target="[data-highlight='my-section']">
//
// The blink targets the most relevant inner element:
//   - .container-el__body for containers
//   - .text-input for inputs
//   - otherwise the element itself

import * as UI from "../ui.js";

const ANIMATION = "highlight-blink 0.5s ease-out 2";

// ordered by specificity, first match wins
const INNER_SELECTORS = [".button", ".text-input"];

function resolveTarget(el) {
  for (const selector of INNER_SELECTORS) {
    const inner = el.querySelector(selector);
    if (inner) return inner;
  }
  return el;
}

function highlight(key) {
  const el = document.querySelector(`[data-highlight="${CSS.escape(key)}"]`);
  if (!el) return;

  const target = resolveTarget(el);

  // Wait for DOM to be settled (Alpine, etc.)
  setTimeout(() => {
    el.scrollIntoView({ behavior: "smooth", block: "center" });
  }, 200);

  setTimeout(() => {
    target.style.animation = ANIMATION;
    target.addEventListener(
      "animationend",
      () => {
        target.style.animation = "";
      },
      { once: true }
    );
  }, 500);
}

UI.onDataActionClick("highlight:trigger", ({ target }) => {
  if (!target) return;
  const key = target.dataset.highlight;
  if (key) highlight(key);
});

function init() {
  const param = new URLSearchParams(window.location.search).get("highlight");
  if (param) highlight(param);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
